import * as httpHelper from '../httpHelper';//网络助手
import { httpUrl } from 'service/api/httpUrl.js'
import {isNoNullAll} from 'utils/js/mixin.js'


/**
 *资源列表
 */
export function getpageResource(params){
  return httpHelper.get('getpageResource',params)
}

/**
 *资源管理列表
 */
export function getlistTheme(params){
  return httpHelper.get('getlistTheme',params)
}

/**
 *查询条件-选择学校
 */
export function getlistSchool(params){
  return httpHelper.get('getlistSchool',params)
}

/**
 *预告列表
 */
export function getNoteList(params){
  return httpHelper.get('getNoteList',params)
}

/**
 *课程预告-管理列表
 */
export function getpageManageList(params){
  return httpHelper.get('getpageManageList',params)
}

/**
 *发布课程预告
 */
export function addcourseNotice(params){
  return httpHelper.postJson('addcourseNotice',params)
}

/**
 *删除预告
 */
export function delcourseNotice(params){
  return httpHelper.post('delcourseNotice',params)
}

/**
 *修改、上下架、删除
 */
export function resourceUpdate(params){
  return httpHelper.post('resourceUpdate',params)
}
